<template>
  <div class="container-fluid">
    <div class="d-flex align-items-center">
      <h2 class="page-heading mr-auto">Денежные средства</h2>
      <btn-action class="btn btn-sm btn-outline-primary mr-1" @click="makeEncashment" v-if="canEncashment">Инкассировать</btn-action>
      <button class="btn btn-sm btn-outline-primary" @click="openModal" v-if="$root.checkPermission('web_ta_money_edit')">Редактировать</button>
    </div>
    <div class="row" v-if="machine">
      <div class="col-md-4 col-sm-12">
        <div class="card mb-4">
          <h3 class="card-header"><span class="text-caps">Купюроприемник</span></h3>
          <div class="card-body">
            <dl class="row mb-0" v-if="machine.money_machines_eva_data">
              <dt class="col-xl-5">Производитель</dt>
              <dd class="col-xl-7">{{machine.banknotes_machine | get('creator.name')}}</dd>
              <dt class="col-xl-5">Модель</dt>
              <dd class="col-xl-7">{{machine | get('money_machines_eva_data.banknotes_machine.model')}}</dd>
              <dt class="col-xl-5">Серийный №</dt>
              <dd class="col-xl-7">{{machine | get('money_machines_eva_data.banknotes_machine.serial_number')}}</dd>
              <dt class="col-xl-5">Версия ПО</dt>
              <dd class="col-xl-7">{{machine | get('money_machines_eva_data.banknotes_machine.software_version')}}</dd>
            </dl>
            <div class="text-muted text-center" v-else>Не задан</div>
          </div>
        </div>
        <div class="card mb-4">
          <h3 class="card-header"><span class="text-caps">Монетоприемник</span></h3>
          <div class="card-body">
            <dl class="row mb-0" v-if="machine.money_machines_eva_data">
              <dt class="col-xl-5">Производитель</dt>
              <dd class="col-xl-7">{{machine.coins_machine | get('creator.name') }}</dd>
              <dt class="col-xl-5">Модель</dt>
              <dd class="col-xl-7">{{machine | get('money_machines_eva_data.coins_machine.model')}}</dd>
              <dt class="col-xl-5">Серийный №</dt>
              <dd class="col-xl-7">{{machine | get('money_machines_eva_data.coins_machine.serial_number')}}</dd>
              <dt class="col-xl-5">Версия ПО</dt>
              <dd class="col-xl-7">{{machine | get('money_machines_eva_data.coins_machine.software_version')}}</dd>
            </dl>
            <div class="text-muted text-center" v-else>Не задан</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="card mb-4">
          <h3 class="card-header"><span class="text-caps">Монеты на сдачу</span></h3>
          <div class="card-body">
            <table class="w-100 table-sm px-0" v-if="coins">
              <thead>
              <tr>
                <th>Номинал</th>
                <th>Остаток</th>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="coin in coins">
                <td><number :number="coin.nominal"/> руб.</td>
                <td><number :number="coin.count"/> шт.</td>
                <td><number :number="coin.sum"/> руб.</td>
                <td class="text-right">
                  <progress-bar
                    :value="coin.count"
                    :max="coin.max"
                    :threshold="machine.coins_tube_threshold"
                    :state="coin.count > machine.coins_tube_threshold ? 'success' : 'danger'"
                    :threshold-title="'Порог на тубу: ' + machine.coins_tube_threshold"
                    class="ml-3"
                    style="min-width: 100px; width: 10vw;"
                  />
                </td>
              </tr>

              <tr>
                <td><strong>Всего</strong></td>
                <td><number :number="machine.coins_count"/> шт.</td>
                <td><number :number="machine.coins_sum"/> руб.</td>
                <td class="text-right">
                  <progress-bar
                    :value="machine.coins_sum"
                    :max="full_count_coins"
                    :threshold="machine.coins_summary_threshold"
                    :state="machine.coins_sum > machine.coins_summary_threshold ? 'success' : 'danger'"
                    :threshold-title="'Общий порог: ' + machine.coins_summary_threshold"
                    class="ml-3"
                    style="min-width: 100px; width: 10vw;"
                  />
                </td>
              </tr>
              </tbody>
            </table>
            <div class="text-muted text-center" v-else>Нет данных</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mb-4">
          <h3 class="card-header"><span class="text-caps">Купюр в автомате</span></h3>
          <div class="card-body">
            <p>
              <number :number="machine.banknotes_sum"/> руб.,
              <number :number="machine.banknotes_count"/> шт.
            </p>
            <div class="media align-items-center">
              <progress-bar
                v-if="machine.banknotes_machine"
                :value="machine.banknotes_count"
                :max="machine.banknotes_machine.full_count_banknotes"
                :threshold="machine.banknotes_count_threshold"
                :state="machine.banknotes_count < machine.banknotes_count_threshold ? 'success' : 'danger'"
                :threshold-title="'Общий порог: ' + machine.banknotes_count_threshold"
                class="ml-3 media-body"
                style="min-width: 100px; width: 10vw;"
              />
              <div class="media-body text-muted text-center" v-else>Купюроприемник не задан</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4 col-/sm-12"> -->
        <!-- <div class="card mb-4">
          <h3 class="card-header"><span class="text-caps">Кассовая лента</span></h3>
          <div class="card-body">
            <template v-if="machine.kkt_type">
              <table class="w-100 table-sm px-0">
                <thead>
                <tr>
                  <th>Тип</th>
                  <th>Остаток</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{machine.kkt_type.name}}</td>
                  <td>{{machine.kkt_remainder}} м</td>
                  <td class="text-right">
                    <progress-bar
                      :value="machine.kkt_remainder"
                      :max="machine.kkt_type.length"
                      :threshold="machine.kkt_threshold"
                      :state="machine.kkt_remainder > machine.kkt_threshold ? 'success' : 'danger'"
                      :threshold-title="'Общий порог: ' + machine.kkt_threshold"
                      class="ml-3"
                      style="min-width: 100px; width: 10vw;"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
              <table class="w-100 table-sm px-0">
                <thead>
                <tr>
                  <th>Длина</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{machine.kkt_type.length}} метров</td>
                </tr>
                </tbody>
              </table>
            </template>
            <div class="text-muted text-center" v-else>Не задана</div>
          </div>
        </div>
        <div class="card mb-4">
          <h3 class="card-header"><span class="text-caps">Длина чека</span></h3>
          <div class="card-body">
            {{machine.cash_voucher_length ? machine.cash_voucher_length * 100 : '25 (значение по умолчанию)'}} сантиметров
          </div>
        </div> -->
      <!-- </div> -->

    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import get from 'lodash/get'
  import isEmpty from 'lodash/isEmpty'
  import CashVoucherForm from '../../../components/cash-voucher-form'
  import moneyModal from '../../../components/machines/modals/money-modal.vue'
  import BtnAction from '../../../components/btn-action'

  export default {
    components: {
      BtnAction,
      CashVoucherForm},
    props: {
      id: {
        required: true,
      },
      machine: {
        type: Object,
      },
    },
    data () {
      return {
        full_count_coins: 0,
      }
    },
    computed: {
      coins () {
        if (isEmpty(this.machine.coins)) return

        this.full_count_coins = 0
        return this.machine.coins.map(coin => {
          const full = get(this.machine, `coins_machine.full_count_coin${coin.nominal}`, 0)
          this.full_count_coins += full * coin.nominal
          return {
            nominal: coin.nominal,
            count: coin.count,
            sum: coin.nominal === 'token' ? coin.count : coin.count * coin.nominal,
            max: full,
          }
        })
      },
      canEncashment () {
        return ['admin', 'branch_admin', 'test_admin', 'service_superior']
          .includes(this.$root.user.role.name)
      },
    },
    methods: {
      openModal () {
        this.$root.showModal(moneyModal, {machine: this.machine})
          .then((data) => {
            this.$emit('update:machine', Object.assign(this.machine, data))
          })
      },
      makeEncashment () {
        return api.post('machines/' + this.id + '/encashment')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/money.vue